window.addEventListener('load', () => {
    AOS.init();
    let scrollRef = 0;
});

// let menu = document.getElementById('menu');
// let offset = menu.offsetHeight;
// window.onscroll = function() {
//     if (window.scrollY > offset-10) {
//         menu.classList.add("sticky");
//     } else if(window.scrollY < offset-20) {
//         menu.classList.remove("sticky");
//     }
// }

jQuery(document).ready(function($){
    console.log('Working');
    $('.review-slider-section__slider--wrap').slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        accessibility: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                }
            },
            {
                breakpoint: 992,
                settings: {
                    arrows: false
                }
            }
        ]

    });
    $('.gallery-slider-section__slider--wrap').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        accessibility: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,

                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: false
                }
            }
        ]

    });

    $('.menu-toggle').click(function(){
        $(".mobile-nav-ul").toggleClass("mobile-nav");
        $(this).toggleClass("is-active");
    });

    $(':header').each(function() {
        if ($(this).next().is(':header')) {
            $(this).css({'padding-bottom': '0', 'margin-bottom': '10px'});
            $(this).next(':header').css({'padding-top': '0', 'margin-top': '0', 'margin-bottom' : '15px'});
        }
    });

    //
    // (function () {
    //     const header = document.querySelector('.header');
    //     const icon = document.querySelector('.icon-container');
    //     icon.onclick = function () {
    //         header.classList.toggle('menu-open');
    //     }
    // }());

    $(document).on('focus', '.ninja-forms-field', function (e) {
        e.preventDefault();
        $(this).closest('.field-wrap').addClass('focused');
    });

    $(document).on('blur', '.ninja-forms-field', function (e) {
        e.preventDefault();
        var $wrap = $(this).closest('.field-wrap');
        var $input = $wrap.find('.nf-field-element .ninja-forms-field');
        if ($input.val().length == 0)
            $wrap.removeClass('focused');
    });

    $('.card-body').hide();

    $(document).on('click', '.faq-accordion-card .card-top', function (e) {
        var $this = $(this);
        var $activeCard = $('.faq-accordion-card.card-active');
        var $parentCard = $this.closest('.faq-accordion-card');
        console.log($activeCard);

        if ($parentCard.hasClass('card-active')) {
            $parentCard.removeClass('card-active').find('.card-body').slideUp();
        } else {
            $activeCard.removeClass('card-active').find('.card-body').slideUp();
            $parentCard.addClass('card-active').find('.card-body').slideDown();
        }
    });


});

